import { useCallback, useSyncExternalStore } from 'react';

// Whether a CSS media query matches, kept true to the window as it is resized
// or turned. For the few things a class cannot do because they are drawn or
// not drawn (Layout.js's assistant button): write the query exactly as the
// stylesheet has it, so the two change at the same width. Where the browser
// cannot say, the answer is false.
export function useMediaQuery(query) {
  const subscribe = useCallback((onChange) => {
    const list = window.matchMedia?.(query);
    if (!list) return () => {};
    // Safari before 14 has only addListener.
    if (list.addEventListener) list.addEventListener('change', onChange);
    else list.addListener?.(onChange);
    return () => {
      if (list.removeEventListener) list.removeEventListener('change', onChange);
      else list.removeListener?.(onChange);
    };
  }, [query]);
  const matches = useCallback(() => window.matchMedia?.(query).matches ?? false, [query]);
  return useSyncExternalStore(subscribe, matches, () => false);
}
